import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isFranceFederationClub } from "../../utils/clubCountryLanguage";
import {
  linkFfttLicence,
  prefillFfttTeams,
  previewFfttRoster,
} from "../../api/ffttClubApi";

export function FfttClubImport({ clubId }) {
  const { t } = useTranslation();
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);

  if (!isFranceFederationClub({ club_id: clubId })) return null;

  const run = async (action) => {
    setBusy(true);
    setNotice("");
    try {
      const data = await action();
      return data;
    } catch (error) {
      setNotice(
        error?.status === "pending_access"
          ? t(
              "ffttAccessPending",
              "FFTT access is not on the server yet. The request goes to the federation, and the key stays on the server."
            )
          : error?.message || t("ffttImportFailed", "FFTT import failed")
      );
      return null;
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="input-detail">
      <label>{t("ffttImportTitle", "FFTT club roster")}</label>
      <p className="group-form__hint">
        {t(
          "ffttImportHint",
          "The server reads licences and championship teams. You confirm each link. People without an account are listed to invite. Their email is not in the federation feed."
        )}
      </p>
      <button
        type="button"
        disabled={busy || !clubId}
        onClick={async () => {
          const data = await run(() => previewFfttRoster(clubId));
          if (data) setPreview(data);
        }}
      >
        {t("ffttImportLicences", "Import licensees")}
      </button>
      <button
        type="button"
        disabled={busy || !clubId}
        onClick={async () => {
          const data = await run(() => prefillFfttTeams(clubId));
          if (!data) return;
          const created = data.created?.length || 0;
          setNotice(
            t("ffttTeamsReady", "{{n}} championship groups prepared. Choose who trains in each one.", {
              n: created,
            })
          );
        }}
      >
        {t("ffttPrefillTeams", "Prepare championship teams")}
      </button>
      {notice ? <p className="group-form__hint">{notice}</p> : null}
      {preview?.matched?.length ? (
        <ul>
          {preview.matched.map((row) => (
            <li key={row.licence}>
              {row.first_name} {row.last_name} · {row.licence}
              <button
                type="button"
                disabled={busy}
                onClick={async () => {
                  const linked = await run(() =>
                    linkFfttLicence({
                      club_id: clubId,
                      player_id: row.player_id,
                      fftt_licence: row.licence,
                      fftt_classement: row.classement,
                      fftt_points: row.points,
                    })
                  );
                  if (!linked) return;
                  setPreview((current) => ({
                    ...current,
                    matched: current.matched.filter((item) => item.licence !== row.licence),
                    already_linked: [...(current.already_linked || []), row],
                  }));
                }}
              >
                {t("ffttLink", "Link")}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      {preview?.unmatched?.length ? (
        <div>
          <p>{t("ffttUnmatchedInvite", "To invite (no account yet, no email from FFTT)")}</p>
          <ul>
            {preview.unmatched.map((row) => (
              <li key={row.licence}>
                {row.first_name} {row.last_name} · {row.licence}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
